import React, { useState, useEffect } from "react";
import TopHeader from "../../Component/Header/TopHeader";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import Paper from "@mui/material/Paper";

import TableRow from "@mui/material/TableRow";
import {
  usePaginationManageSubscribersMutation,
} from "../../app/services/manageSubscribersService";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ReactPaginate from "react-paginate";
import Spinner from "../../Component/spinner/spinner";
import { Button, Container } from "@mui/material";
// import {
//   selectCurrentScope,
// } from "../../app/auth/authSlice";
// import { useSelector } from "react-redux";


//table head for category
function EnhancedCategoryTableHead() {
  const headCells = [
    {
      id: "email",
      numeric: false,
      disablePadding: false,
      label: "Email"
    },
    // {
    //   id: "subCategoryname",
    //   numeric: true,
    //   disablePadding: false,
    //   label: "Sub Category Name"
    // },
  ];

  return (
    <>
      <TableHead>
        <TableRow className="menus-color">
          {headCells.map((headCell) => (
            <TableCell
              sx={{ textAlign: "center", color: "#ffff" }}
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
            >
              {headCell.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    </>
  );
}

const ManageSubscribers = () => {

  const [loading, setLoading] = useState(true);
  const [page, setPage] = React.useState(0); //state for set page
  const [getAllPaginationSubscribers] = usePaginationManageSubscribersMutation(); //API call of Get all
  //   const [type, setType] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [allSubscribers, setAllSubscribers] = useState([]);
  //   const memberScope = useSelector(selectCurrentScope);
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [error, setError] = useState("");


  //   const handleClose = () => setOpen(false);
  //calling event data
  useEffect(() => {
    const data = { type: 0 };
    fetchData(data);
    // Fetch data on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, itemsPerPage]); // Update useEffect dependencies

  //getAllPendingEventList
  const fetchData = (datas) => {
    var data = {
      page: page + 1,
      itemsPerPage: itemsPerPage,
    };
    getAllPaginationSubscribers(data)
      .then((res) => {
        setLoading(false);
        setAllSubscribers(res?.data?.data?.subscriptionDetails || []);
        setTotalPage(res?.data?.data.totalCount || 0);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching pending event list:", error);
      });
  };

  //page Click for category
  const handlePageClick = ({ selected }) => {
    setSearchTerm('')
    setError("");
    setPage(selected);
  };

  //sliced category
  const SlicedSubscribers = allSubscribers// Adjust slicing

  //calculate pagecount
  const pageCount = Math.ceil(totalPage / itemsPerPage);

  const handlePageChange = () => {
    const pageNumber = Number(searchTerm);
    if (isNaN(pageNumber) || pageNumber < 0) {
      setError("Page number cannot be less than 1");
    } else if (pageNumber > pageCount) {
      setError("Please enter valid page number");
    } else if (pageNumber === 0) {
      setError("Please enter page number");
    } else {
      setError("");
      setPage(pageNumber - 1);
    }
  };

  return (
    <div>
      <TopHeader />
      <div className="pt-5">
        <div className="chapter-heading">
          <h2 className="text-center title-font text-light py-3 mt-1">Manage Subscribers</h2>
        </div>
      </div>

      <Container maxWidth={'xxl'} className='p-md-5 p-3 overallPadding'>
        {/* </Container> */}
        {loading ? (
          <Spinner />
        ) : (
          <Box className="mb-5 p-0">
            <Paper sx={{ width: "100%", mb: 4 }}>
              <div className='w-100 text-end mb-3 '>
                <Button
                  onClick={() => window.history.back()}
                  variant="contained"
                  className="menus-color"
                >
                  Back
                </Button>
              </div>
              <TableContainer className="mb-5">
                <Table aria-labelledby="tableTitle">
                  <EnhancedCategoryTableHead />
                  <TableBody>
                    {SlicedSubscribers.length > 0 ? (
                      SlicedSubscribers.map((category, index) => (
                        <TableRow
                          hover
                          key={category._id}
                          sx={{
                            cursor: "pointer",
                            backgroundColor:
                              index % 2 === 0 ? "#f0f0f0" : "white",
                          }}
                        >
                          <TableCell align="center">
                            {category.email}
                          </TableCell>

                        </TableRow>
                      ))
                    ) : (
                      <>
                        <TableRow>
                          <TableCell colSpan={5}>
                            <p className="text-black text-center">
                              No Data Available
                            </p>
                          </TableCell>
                        </TableRow>
                      </>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

            </Paper>
            {SlicedSubscribers.length > 0 ? (

              <div className="d-flex justify-content-between flex-md-row flex-column gx-3 gx-md-0 content-font" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "56px" }}>
                <div className="mb-2 mb-md-0">
                  <div className="d-flex gap-2">
                    <input
                      type="number"
                      min={1}
                      placeholder="Page no."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="search-input"
                    />
                    <div className="goPage cursor-pointer" onClick={handlePageChange}>
                      <h5 className="p-2 m-0">Go</h5>
                    </div>
                  </div>
                  {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}
                </div>

                {/* Pagination in the Center */}
                <div className="my-3 my-md-0">
                  <ReactPaginate
                    pageCount={pageCount} // Calculate total pages
                    pageRangeDisplayed={1}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    disabledClassName={"disablebtn"}
                    forcePage={page}
                    previousLabel={pageCount > 1 && page >= 1 ? "Previous" : null}
                    nextLabel={
                      pageCount > 1 && page + 1 !== pageCount ? "Next" : null
                    }
                  />
                </div>
                <div className="mb-2 mb-md-0">
                  <FormControl variant="outlined">
                    <InputLabel></InputLabel>
                    <Select
                      className="itemsperpage"
                      value={itemsPerPage}
                      onChange={(e) => {
                        const value = e.target.value;
                        setItemsPerPage(value);
                        setError('');
                        setSearchTerm('');
                        setPage(0);
                      }}
                      MenuProps={{
                        MenuListProps: {
                          sx: {
                            display: 'flex',
                            flexDirection: 'column',
                          },
                        },
                      }}
                    >
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={50}>50</MenuItem>
                      <MenuItem value={100}>100</MenuItem>
                    </Select>

                  </FormControl>
                </div>
              </div>
            ) : (
              <></>
            )}
          </Box>

        )}
      </Container>
    </div>
  );
}

export default ManageSubscribers;

